/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BusinessRelationLifecycle = {
    Operating: 'OPERATING',
    Onboarding: 'ONBOARDING',
    Closed: 'CLOSED',
    Offboarding: 'OFFBOARDING',
    Prospecting: 'PROSPECTING',
    Withdrawn: 'WITHDRAWN'
} as const;
export type BusinessRelationLifecycle = typeof BusinessRelationLifecycle[keyof typeof BusinessRelationLifecycle];


export function instanceOfBusinessRelationLifecycle(value: any): boolean {
    for (const key in BusinessRelationLifecycle) {
        if (Object.prototype.hasOwnProperty.call(BusinessRelationLifecycle, key)) {
            if (BusinessRelationLifecycle[key as keyof typeof BusinessRelationLifecycle] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BusinessRelationLifecycleFromJSON(json: any): BusinessRelationLifecycle {
    return BusinessRelationLifecycleFromJSONTyped(json, false);
}

export function BusinessRelationLifecycleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessRelationLifecycle {
    return json as BusinessRelationLifecycle;
}

export function BusinessRelationLifecycleToJSON(value?: BusinessRelationLifecycle | null): any {
    return value as any;
}

export function BusinessRelationLifecycleToJSONTyped(value: any, ignoreDiscriminator: boolean): BusinessRelationLifecycle {
    return value as BusinessRelationLifecycle;
}

